"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hideLoader = hideLoader;
exports.showLoader = showLoader;
exports.addRow = addRow;
exports.deleteRow = deleteRow;
exports.setPropertiesRow = setPropertiesRow;
exports.setPropertiesShowPower = setPropertiesShowPower;
exports.setPropertiesPressure = setPropertiesPressure;
exports.setPropertiesAirFlow = setPropertiesAirFlow;
exports.setPropertiesGenerate = setPropertiesGenerate;
exports.setPropertiesShowChart = setPropertiesShowChart;
exports.selectedCulture = selectedCulture;
function hideLoader() {
    return {
        type: "psychrometric-tool/HIDE-LOADER"
    };
}
function showLoader() {
    return {
        type: "psychrometric-tool/SHOW-LOADER"
    };
}
function addRow() {
    return {
        type: "psychrometric-tool/ADD-ROW",
        payload: {}
    };
}
function deleteRow(rowIndex) {
    return {
        type: "psychrometric-tool/DELETE-ROW",
        payload: { rowIndex }
    };
}
function setPropertiesRow(pvs, rowIndex) {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-ROW",
        payload: {
            pvs,
            rowIndex
        }
    };
}
function setPropertiesShowPower(pvs) {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-SHOW-POWER",
        payload: pvs
    };
}
function setPropertiesPressure(pvs) {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-PRESSURE",
        payload: pvs
    };
}
function setPropertiesAirFlow(pvs) {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-AIR-FLOW",
        payload: pvs
    };
}
function setPropertiesGenerate() {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-GENERATE"
    };
}
function setPropertiesShowChart() {
    return {
        type: "psychrometric-tool/SET-PROPERTIES-SHOW-CHART"
    };
}
function selectedCulture(selectedOption) {
    return {
        type: "psychrometric-tool/SELECTED-CULTURE",
        payload: selectedOption
    };
}
//# sourceMappingURL=actions.js.map